import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, lastValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  public buildParams(filters: any): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params = params.set(key, value.toString());
      }
    });
    return params;
  }

  public buildParamsString(filters: any): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, value.toString());
      }
    });
    return params;
  }

  public async getServices<T extends readonly [...Observable<any>[]]>(
    observables: T,
  ): Promise<{ [K in keyof T]: T[K] extends Observable<infer R> ? R : never }> {
    return (await lastValueFrom(combineLatest(observables))) as any;
  }

  // Trasforma un Json a string
  public jsonToString(data: any): string {
    return JSON.stringify(data);
  }
  // Trasforma un string a Json
  public stringToJson(jsonString: string | null): any {
    try {
      return JSON.parse(jsonString ?? '');
    } catch (error) {
      return null;
    }
  }
}
